var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h3',[_vm._v("关于我们")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.str)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }